import {
  SET_RECENT_CHATS,
  UPDATE_RECENT_CHATS,
  SET_ACTIVE_CHAT,
  SET_ACTIVE_CHAT_MESSAGES,
  UPDATE_ACTIVE_CHAT_MESSAGES,
  LEAVE_CHAT,
  JOIN_CHAT,
  SET_UNREAD_NUMBER,
  SET_REQUESTING_MESSAGES_CHAT_ID,
  ADD_ACTIVE_CHAT_NEW_MESSAGE,
  READ_MESSAGE,
  UPDATE_LAST_MESSAGE,
  UPDATE_USER_ACTIVITY,
  RESET_RECENT_CHATS,
  SLICE_ACTIVE_CHAT_MESSAGES,
  SET_USERS_NUMBER,
  MARK_ACTIVE_CHAT_AS_READ,
  SET_RECONNECTION_ATTEMPTS,
  SET_ACTIVE_CHAT_ID
} from '@/store/modules/chats/types';

import CONSTANTS from '@/constants';
import { mergeSort } from '@/utils';

export default {
  [SET_RECENT_CHATS]: (state, data) => {
    const chats = mergeSort(data.chats, 'updated_at');

    if (!state.recentChats.length) {
      state.recentChats = chats;
    } else {
      state.recentChats = mergeSort([...state.recentChats, ...chats], 'updated_at');
    }

    const unread = {};
    chats.forEach(chat => { unread[chat.id] = chat.unread; });
    state.unreadMessagesCount = { ...state.unreadMessagesCount, ...unread };

    if (data.meta) {
      data.meta.from = state.recentChats[state.recentChats.length - 1].updated_at;
      Object.assign(state.recentChatsMeta, data.meta);
    }
  },
  [RESET_RECENT_CHATS]: state => {
    state.recentChats = [];
    state.recentChatsMeta = {
      from: null,
      next_page: null,
      per_page: CONSTANTS.chatsPageSize
    };
  },
  [UPDATE_RECENT_CHATS]: (state, data) => {
    data.chats.map(chat => {
      chat.last_message = chat.last_message || null;
      return chat;
    });

    if (!state.recentChats.length) {
      state.recentChats.push(data);
    } else {
      const chat = state.recentChats.find(i => i.id === data.id);
      if (!chat) state.recentChats.unshift(data);
    }
  },
  [SET_ACTIVE_CHAT]: (state, data) => {
    state.activeChat = data;
  },
  [SET_ACTIVE_CHAT_MESSAGES]: (state, data) => {
    state.activeChatMetaTo = data.meta.to || data.meta;
    state.activeChatUsers = data.users;
    state.activeChatMessages = data.messages;

    if (data.meta.from) {
      state.activeChatMetaFrom = data.meta.from;
    } else {
      Object.keys(state.activeChatMetaFrom).forEach(key => {
        state.activeChatMetaFrom[key] = null;
      });
    }

    if (data.messages && data.messages.length) {
      data.messages.sort((a, b) => a.id - b.id);

      const firstUnread = data.messages.find(msg => !msg.is_read);
      state.activeChatFirstUnread = (firstUnread && firstUnread.id) || null;
    } else {
      state.activeChatFirstUnread = null;
    }
  },
  [MARK_ACTIVE_CHAT_AS_READ]: state => {
    state.activeChatMessages.forEach(m => {
      m.is_read = true;
    });
  },
  [ADD_ACTIVE_CHAT_NEW_MESSAGE]: (state, message) => {
    if (state.activeChatMessages && state.activeChatMessages.length) {
      state.activeChatMessages.push(message);
    } else {
      state.activeChatMessages = [message];
    }
  },
  [UPDATE_ACTIVE_CHAT_MESSAGES]: (state, data) => {
    const messages = state.activeChatMessages.concat(data.messages);

    state.activeChatMessages = messages.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    state.activeChatUsers = { ...state.activeChatUsers, ...data.users };

    if (data.direction === 'next') {
      state.activeChatMetaTo = data.meta;
    }

    if (data.direction === 'prev') {
      state.activeChatMetaFrom = data.meta;
    }
  },
  [SLICE_ACTIVE_CHAT_MESSAGES]: (state, { diff, direction }) => {
    if (direction === 'next') {
      state.activeChatMessages.splice(state.activeChatMessages.length - diff);
      state.activeChatMetaFrom.next_page = true;
    }

    if (direction === 'prev') {
      state.activeChatMessages.splice(0, diff);
      state.activeChatMetaTo.next_page = true;
    }
  },
  [LEAVE_CHAT]: (state, chat) => {
    // TODO: remove once the left_at attribute will be provided by the server
    chat.left_at = Date.now();

    if (state.activeChat.id === chat.id) {
      state.activeChat = chat;
    }
    const leavedIndex = state.recentChats.findIndex(i => i.id === chat.id);

    if (leavedIndex !== -1) {
      state.recentChats.splice(leavedIndex, 1, chat);
    }
  },
  [JOIN_CHAT]: (state, chat) => {
    if (state.activeChat.id === chat.id) {
      state.activeChat = chat;
    }
    const joinedIndex = state.recentChats.findIndex(i => i.id === chat.id);

    if (joinedIndex !== -1) {
      state.recentChats.splice(joinedIndex, 1, chat);
    }
  },
  [SET_UNREAD_NUMBER]: (state, data) => {
    state.unreadMessagesCount = { ...state.unreadMessagesCount, [data.chat_id]: data.unread };
  },
  [SET_REQUESTING_MESSAGES_CHAT_ID]: (state, data) => {
    state.requestingMessagesChatId = data;
  },
  [READ_MESSAGE]: (state, data) => {
    const msg = state.activeChatMessages.find(i => i.id === data.message_id);

    if (msg) msg.is_read = true;
  },
  [UPDATE_LAST_MESSAGE]: (state, { message, chatIndex }) => {
    state.recentChats[chatIndex].last_message = message;

    if (chatIndex > 0) {
      const chat = state.recentChats.splice(chatIndex, 1);
      state.recentChats = chat.concat(state.recentChats);
    }
  },
  [UPDATE_USER_ACTIVITY]: (state, data) => {
    if (state.recentChats.length) {
      state.recentChats.forEach(i => {
        if (i.type_id === CONSTANTS.chatTypes.private && i.contact && i.contact.id === data.user_id) {
          i.contact.active_at = data.active_at;
        }
      });
    }
  },
  [SET_USERS_NUMBER]: (state, data) => {
    const chat = state.recentChats.find(c => c.id === data.id);

    if (chat) {
      chat.users_number = data.number;
    }
  },
  [SET_RECONNECTION_ATTEMPTS]: (state, data) => {
    state.reconnectionAttempts = data;
  },
  [SET_ACTIVE_CHAT_ID]: (state, id) => {
    state.activeChatId = id;
  }
};
